import { Vue, Component } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import { gtmTrackingService } from "@services/gtm-tracking.service";
import { Emitter } from "@utils/events";

@Component({})
export class BaseView extends Vue {
  public initialized = false;
  public print: boolean = false;

  public get dirty(): boolean {
    return false;
  }

  public async initialize(): Promise<void> {
    await this.$nextTick();
    this.initialized = true;
    this.afterInitialize();
  }

  public async afterInitialize(): Promise<void> {
    // after initialize hook
  }

  public manualGTMUpdate(): boolean {
    return false;
  }

  public setupPrinting(): void {
    window.onbeforeprint = () => (this.print = true);
    window.onafterprint = () => (this.print = false);
    Emitter.on("ci::page::print", () => (this.print = true));
  }

  protected async beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
    next(() => {
      if (!this.manualGTMUpdate()) this.gtmReinitialize(to, from);
    });
  }

  protected async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
    next((vm: any) => {
      if (!vm.manualGTMUpdate()) vm.gtmReinitialize(to, from);
    });
  }

  protected async beforeRouteLeave(_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> {
    if (this.dirty) {
      const response = await this.confirmLeave();
      if (response) next();
    } else {
      // Navigate to next view
      next();
    }
  }

  protected gtmReinitialize(to: Route, from: Route, options?: Indexable): void {
    if (from.name) {
      gtmTrackingService.reinitialize(from.fullPath, to.meta?.pageType, options);
    }
  }

  protected beforeMount(): void {
    window.addEventListener("beforeunload", this.beforeWindowUnload, true);
  }

  protected beforeDestroy(): void {
    window.removeEventListener("beforeunload", this.beforeWindowUnload, true);
  }

  private beforeWindowUnload(e: Event): void {
    if (this.dirty) {
      e.preventDefault();
      e.returnValue = false;
    }
  }

  private async confirmLeave(): Promise<boolean> {
    const messageBoxOptions = {
      title: this.$t("confirm_leave.attention") as string,
      okTitle: this.$t("confirm_leave.leave") as string,
      okVariant: "danger",
      bodyClass: "text-sm",
      modalClass: "ci-modal ci-modal-flexible ci-modal-size-md",
      cancelTitle: this.$t("action.cancel") as string,
    };
    const response = await this.$bvModal.msgBoxConfirm(
      this.$t("confirm_leave.unsaved_data") as string,
      messageBoxOptions
    );
    return response;
  }
}
